import { apiSlice } from '../../../app/services/apiSlice';
import { STATUSES } from '../../../utils/Statuses';
import { getFullName } from '../../kanban/components/hiringListing/hiringUtils';

const APPROVER_PREFIX = 'approvers';


export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getHiringManagerListing: builder.mutation({
      query: (params) => ({
          url: `accounts`,
          params: {
            ...params,
          roleAccessKey: 'HIRING_MANAGER',
          filters: STATUSES.ACTIVE
         },
      }),
      transformResponse: (responseData) => {
          responseData.options = responseData?.accounts?.map((team) => ({
              ...team,
          }));
          return responseData || {};
      },
  }),
  getRecruiterListing: builder.mutation({
    query: (params) => ({
        url: `accounts`,
        params:{
            ...params,
            roleAccessKey:"RECRUITER",
            filters: STATUSES.ACTIVE
        },
    }),
    transformResponse: (responseData) => {
      responseData.options = responseData?.accounts?.map((team) => ({
        ...team,
        title: getFullName(team),
      }));
      return responseData || {};
    },
}),
    getInterviewersListing: builder.mutation({
      query: (params) => ({
          url: `accounts`,
          params:{
              ...params,
              roleAccessKey: "INTERVIEWER",
              filters : STATUSES.ACTIVE
          },
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.accounts?.map((team) => ({
          ...team,
          title: getFullName(team),
        }));
        return responseData || {};
      },
    }),
  getApprovers: builder.mutation({
    query: (params) => ({
        url: `accounts`,
        params: {
          ...params,
          roleAccessKey: 'APPROVER',
          filters: STATUSES.ACTIVE,
        },
    }),
    transformResponse: (responseData) => {
        responseData.options = responseData?.accounts?.map((team) => ({
            ...team,
        }));
        return responseData || {};
    },
}),
    getAllCompanyUsers: builder.mutation({
      query: (params) => ({
        url: `${APPROVER_PREFIX}`,
        params,
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.accounts?.map((account) => ({
          ...account,
          value: account?.id,
          title: `${account?.firstName || ''} ${account?.lastName || ''}`,
        }));
        responseData.total = responseData?.totalCount;
        responseData.page = responseData.currentPage;
        return responseData || {};
      },
    }),
  }),
});

export const {
  useGetAllSigneeMutation,
  useGetInterviewersListingMutation,
  useGetApproversMutation,
  useGetHiringManagerListingMutation,
  useGetRecruiterListingMutation,
} = extendedApiSlice;
